import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';

import cx from 'classnames';
import {
  MAX_ATTACHMENT_FILE_SIZE_IN_BYTES,
  MAX_ATTACHMENT_FILE_SIZE_IN_MEGABYTES_STRING
} from 'constants/environment';

import { ReactComponent as InstallIcon } from 'pages/Teachers/Assignments/MathAssignmentCreateFlow/assets/install.svg';
import { ReactComponent as PdfIcon } from 'pages/Teachers/Assignments/MathAssignmentCreateFlow/assets/pdf.svg';
import { ReactComponent as UploadIcon } from 'pages/Teachers/Assignments/MathAssignmentCreateFlow/assets/upload.svg';
import { uploadFile } from 'utils/files';

import styles from './styles.module.scss';

const ExemplarUpload = ({ file, setFile }) => {
  const [isUploading, setIsUploading] = useState(false);

  const onDrop = useCallback(
    async (acceptedFiles) => {
      const selectedFile = acceptedFiles[0];
      if (!selectedFile) return;

      setIsUploading(true);
      try {
        const uploadedId = await uploadFile({
          blob: selectedFile,
          name: selectedFile.name,
          maxSize: {
            sizeInBytes: MAX_ATTACHMENT_FILE_SIZE_IN_BYTES,
            sizeAsString: MAX_ATTACHMENT_FILE_SIZE_IN_MEGABYTES_STRING
          }
        });

        setFile({
          name: selectedFile.name,
          pages: '1',
          id: uploadedId
        });
      } catch (error) {
        console.error('Upload failed', error);
      } finally {
        setIsUploading(false);
      }
    },
    [setFile]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: 'image/*,application/pdf',
    multiple: false
  });

  const handleRemove = (e) => {
    e.stopPropagation(); // Prevent re-triggering the upload dialog
    setFile(null);
  };

  return (
    <div className={styles.fieldSection}>
      <div className={styles.fieldLabel}>
        <InstallIcon /> <span>Upload Exemplar</span>
      </div>

      {!file ? (
        <div
          {...getRootProps()}
          className={cx(styles.dropzone, {
            [styles.dropzoneActive]: isDragActive
          })}
        >
          <input {...getInputProps()} />
          <UploadIcon className={styles.dropzoneIcon} />
          <p>
            <span className={styles.linkText}>
              {isUploading ? 'Uploading...' : 'Choose file to upload'}
            </span>
            {!isUploading && ' or drag and drop'}
          </p>
        </div>
      ) : (
        <div className={styles.fileRow}>
          <div className={styles.fileInfo}>
            <PdfIcon />
            <span className={styles.fileName}>{file.name}</span>
          </div>

          <div className={styles.fileActions}>
            <input
              type="text"
              placeholder="No. of pages"
              className={styles.pagesInput}
              value={file.pages}
              onChange={(e) => setFile({ ...file, pages: e.target.value })}
            />
            <button className={styles.removeFile} onClick={handleRemove}>
              ×
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExemplarUpload;
